var sliderthumbs = new Swiper('[data-article-thumbnail]', {
  slidesPerView: 'auto',
  spaceBetween: 10,
  slideToClickedSlide: true,
  freeMode: true,
  watchSlidesVisibility: true,
  watchSlidesProgress: true,
});

var slider = new Swiper('[data-article-gallery]', {
  slidesPerView: 1,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  thumbs: {
    swiper: sliderthumbs, 
  },
});